import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {IFormField} from "../../../../../../shared/components/form-field-wrapper/form-field-wrapper.component";
import {UntypedFormControl} from "@angular/forms";
declare var $: any;


@Component({
    selector: 'app-global-answer',
    templateUrl: './global-answer.component.html',
    styleUrls: ['./global-answer.component.scss'],
    standalone: false
})
export class GlobalAnswerComponent implements OnInit {

  @Input() question: IFormField;
  @Input() myFormControl: UntypedFormControl;
  @Input() setGlobal?: Function;
  @Input() isUnassignedPopulation: boolean;
  @ViewChild('globe') globe: ElementRef;

  constructor() { }

  ngOnInit() {}

  ngAfterViewInit() {
    if (!this.myFormControl.value) return false;

    $(this.globe.nativeElement).popup({
      position: "top center",
      inline: false,
      variation: "inverted",
      delay: {
        show: 500
      }
    });
  }
}
